<template>
	<div class="video">
		<video
			v-if="withVideo"
			:style="customStyle"
			autoplay
			loop
			muted
			webkit-playsinline
			playsinline
			poster="@/assets/video/cover.jpg"
		>
			<source src="@/assets/video/paywall-video-female-alternative.mp4" type="video/mp4" />
		</video>
		<img v-else src="@/assets/video/cover.jpg" alt="" />
	</div>
</template>

<script setup>
defineProps({
	withVideo: {
		type: Boolean,
		default: true
	},
	customStyle: {
		type: Object,
		default: () => ({})
	}
})
</script>

<style scoped lang="scss">
.video {
	max-width: 500px;
	margin-left: auto;
	margin-right: auto;
	pointer-events: none;
	position: relative;

	img {
		display: block;
	}

	* {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.01);
	}

	video {
		display: block;
		width: 100%;
		object-fit: cover;
	}
}

video::-webkit-media-controls {
	display: none !important;
}

*::-webkit-media-controls-panel {
	display: none !important;
	-webkit-appearance: none;
}

*::-webkit-media-controls-play-button {
	display: none !important;
	-webkit-appearance: none;
}

*::-webkit-media-controls-start-playback-button {
	display: none !important;
	-webkit-appearance: none;
}
</style>
